export const properties = {
  disabled: 'Zablokowanie',
  visible: 'Widoczność',
  highlighted: 'Podświetlenie',
  triggerInfo: 'Stan wyzwalacza',
  infoValue: 'Wartość wyzwalacza',
  hideLabel: 'Ukrycie etykiety',
  subStep: 'Pod-krok',
  focus: 'Rozwinięcie',
  tooltips: {
    disabled: 'Określa czy krok ma być domyślnie zablokowany',
    visible: 'Określa czy krok ma być domyślnie widoczny',
    highlighted: 'Określa czy krok ma być domyślnie  podświetlony',
    triggerInfo: 'Określa czy wyzwalacz ma być domyślnie aktywny',
    infoValue: 'Określa tekst wartości wewnątrz wyzwalacza',
    hideLabel: 'Określa czy etykieta elementu ma być domyślnie ukryta',
    subStep: 'Określa czy pod-krok ma być domyślnie widoczny',
    focus: 'Określa czy krok ma być domyślnie rozwinięty',
  },
  saveSuccess: 'Właściwość została zaktualizowana',
} as const
